export default (params,viewFloor) => params.reduce((res,d) => {
  return res.concat(...d.locations.map(x=>{
    return {
      ...x,
      viewLocation: d.name,
      viewFloor: x.viewFloor || viewFloor,
    }
  }))
},[])
